import { useMemo } from "react";
import { useSelector } from "react-redux";
import { currentToken } from "../redux/features/userSlice";

const useAuth = () => {
  const token = useSelector(currentToken);
  console.log(token);

  return useMemo(() => ({ token }), [token]);
};
export default useAuth;